<template>
  <div>
    <div :class="settings.isLightTheme ? [$style.navigation, $style.light] : $style.navigation">
      <vue-custom-scrollbar
        :class="settings.isMobileView ? $style.scrollbarMobile : $style.scrollbarDesktop"
      >
        <a-menu
          :theme="'dark'"
          :inlineCollapsed="withDrawer ? false : settings.isMenuCollapsed"
          :mode="'inline'"
          :selectedKeys="selectedKeys"
          :openKeys.sync="openKeys"
          @click="handleClick"
          @openChange="handleOpenChange"
        >
          <template v-for="(item, index) in menuData">
            <item
              v-if="!item.children && !item.divider"
              :menu-info="item"
              :styles="$style"
              :key="item.key"
              :class="$style.topmenu"
            />
            <a-menu-divider v-if="item.divider" :key="index"/>
            <sub-menu v-if="item.children" :menu-info="item" :styles="$style" :key="item.key"/>
          </template>
        </a-menu>
      </vue-custom-scrollbar>
    </div>
  </div>
</template>

<script>
import store from 'store'
import _ from 'lodash'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { getLeftMenuData } from '@/services/menu'
import SubMenu from './partials/submenu'
import Item from './partials/item'

export default {
  name: 'menu-left',
  components: { vueCustomScrollbar, SubMenu, Item },
  props: {
    settings: Object,
    withDrawer: {
      type: Boolean,
      default: false,
    },
    userDetails: Object,
  },
  mounted() {
    this.openKeys = store.get('app.menu.openedKeys') || []
    this.selectedKeys = store.get('app.menu.selectedKeys') || []
    this.setSelectedKeys()
  },
  data() {
    return {
      menuData: [],
      selectedKeys: [],
      openKeys: [],
    }
  },
  watch: {
    'settings.isMenuCollapsed'() {
      this.openKeys = []
    },
    '$route'() {
      this.setSelectedKeys()
    },
  },
  methods: {
    handleClick(e) {
      if (e.key === 'settings') {
        this.$store.commit('CHANGE_SETTING', { setting: 'isSettingsOpen', value: true })
        return
      }
      store.set('app.menu.selectedKeys', [e.key])
      this.selectedKeys = [e.key]
    },
    handleOpenChange(openKeys) {
      store.set('app.menu.openedKeys', openKeys)
      this.openKeys = openKeys
    },
    setSelectedKeys() {
      this.checkRouting()
      let pathname = this.$route.path
      const menuData = this.menuData.concat()
      const flattenItems = (items, key) =>
        items.reduce((flattenedItems, item) => {
          flattenedItems.push(item)
          if (Array.isArray(item[key])) {
            return flattenedItems.concat(flattenItems(item[key], key))
          }
          return flattenedItems
        }, [])

      let selectedItem
      do {
        selectedItem = _.find(flattenItems(menuData, 'children'), [
          'url',
          pathname,
        ])

        var path = pathname.split('/')
        path.splice(path.length - 1, 1)
        pathname = path.join('/')
      }
      while (selectedItem === undefined && pathname.length > 0)

      this.selectedKeys = selectedItem ? [selectedItem.key] : []
    },
    checkRouting() {
      const accessToken = JSON.parse(localStorage.getItem('okta-token-storage'))
      if (accessToken && accessToken.accessToken.accessToken) {
        if (this.$route.path === '/unauthorized') {
          this.$router.push('/dashboard')
        }
        const user = JSON.parse(localStorage.getItem('userDetails'))
        if (user) {
          this.menuData = getLeftMenuData.filter(i => (i.roles.includes(user.role)))
          const valid = this.menuData.find(i => i.url && i.url.split('/')[1] === this.$route.path.split('/')[1])
          if (!valid && this.$route.path.split('/')[1] !== 'releaseNotes') {
            this.$router.push('/dashboard')
          }
        }
      } else {
        this.$router.push('/unauthorized')
      }
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";

</style>
